import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./English/en.json";
import translationAR from "./Arabic/ar.json";
import translationFr from "./frensh/fr.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "ar", "fr"];

const resources = {
  ar: {
    translation: translationAR,
  },
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFr,
  },
};


const savedLanguage = localStorage.getItem("kalemon-language");


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    lng: savedLanguage || "en",

    detection: {
      checkWhitelist: true,
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });


i18n.on("languageChanged", (lng) => {
  localStorage.setItem("kalemon-language", lng);
});

export default i18n;
